import { DateTime } from "luxon";

// Same wall-clock frame as the server: session dates are the club's wall time
// labeled Z, so all math here stays in the UTC frame.
export const wall = (iso) => DateTime.fromISO(iso, { zone: "utc" });

// End of a validity window that starts on `startDay` — a 1-month window from
// Jan 1 ends Jan 31, not Feb 1 (mirrors the server's getPaidPlansDates shape).
export const windowEnd = (startDay, dur, unit) => startDay.plus({ [unit]: dur }).minus({ days: 1 }).endOf("day");

export const sessionGridSx = { display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)" }, gap: 1 };

export const spotsLabel = (c) => (c.spotsAvailable != null ? `${c.spotsAvailable} spot${c.spotsAvailable === 1 ? "" : "s"} left` : null);

export const spotsColour = (c) => {
  if (c.spotsAvailable == null) return "text.secondary";
  if (c.spotsAvailable <= 1) return "error.main";
  if (c.spotsAvailable <= 3) return "warning.main";
  return "text.secondary";
};
